import React from "react";
import { useHistory } from "react-router-dom";
import { IconButton } from "@material-ui/core";

import { Icon, HeaderBackButton } from "../../components";
import { TagLabel } from "./style";

import firebaseEvent from "../../utils/firebaseEvent";
// import { getStorage } from "../../utils/storage";

export interface Props {
  tag: string;
}
const SearchResultHeader = ({ tag }: Props) => {
  const history = useHistory();
  const hashtagDecode = (tag: string) => {
    return decodeURIComponent(tag).replace(/percent2e5/gi, "%");
    // if (getStorage("select_type") === "hashtag") {
    //   const result = decodeURIComponent(tag).replace("#", "");
    //   return `#${result}`;
    // } else {
    //   const result = searchValue !== "" ? searchValue : tag;
    //   return result;
    // }
  };

  const HomeButton = () => {
    const onClick = () => {
      //Firebase Event

      firebaseEvent("click_home");
      history.replace("/feeds");
    };
    return (
      <IconButton onClick={onClick}>
        <Icon name="home" size={28} />
      </IconButton>
    );
  };

  return (
    <React.Fragment>
      <HeaderBackButton />
      <TagLabel variant="subtitle1" align="center" dir="auto">
        {hashtagDecode(tag)}
      </TagLabel>
      <HomeButton />
    </React.Fragment>
  );
};

export default SearchResultHeader;
